exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.boton {\n  background-color: #ffe800 !important;\n  color: black !important;\n}\n", ""]);

// exports
